import style from "./style.module.css";

const Main = () => {
  return (
    <div className={style.main}>
      <h1>Welcome</h1>
    </div>
  );
};

export default Main;
